import { render, staticRenderFns } from "./ImportExcel.vue?vue&type=template&id=22b5d9dd&scoped=true"
import script from "./ImportExcel.vue?vue&type=script&lang=js"
export * from "./ImportExcel.vue?vue&type=script&lang=js"
import style0 from "./ImportExcel.vue?vue&type=style&index=0&id=22b5d9dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b5d9dd",
  null
  
)

export default component.exports